import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import ReactHTMLTableToExcel from "react-html-table-to-excel"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeRefundUserPayed extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,

                  RefundUser: null,
                  orderBy: "refund_user_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newFinancialDoc: true,

                  refundUserMaxDate: "",
                  refundUserMinDate: "",
                  refundUserMaxAmount: "",
                  refundUserMinAmount: "",

                  refundPayMaxDate: "",
                  refundPayMinDate: "",
            }
      }

      setSelectedDayMax = (event) => {
            this.setState({ refundUserMaxDate: event }, () => {
                  this.filterList()
            })
      }

      clearDeyMax = (event) => {
            this.setState({ refundUserMaxDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayMin = (event) => {
            this.setState({ refundUserMinDate: event }, () => {
                  this.filterList()
            })
      }

      clearDeyMin = (event) => {
            this.setState({ refundUserMinDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedPayDayMax = (event) => {
            this.setState({ refundPayMaxDate: event }, () => {
                  this.filterList()
            })
      }

      clearPayDeyMax = (event) => {
            this.setState({ refundPayMaxDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedPayDayMin = (event) => {
            this.setState({ refundPayMinDate: event }, () => {
                  this.filterList()
            })
      }

      clearPayDeyMin = (event) => {
            this.setState({ refundPayMinDate: "" }, () => {
                  this.filterList()
            })
      }

      handleChangeMaxAmount = (event) => {
            this.setState({ refundUserMaxAmount: event }, () => {
                  this.filterList()
            })
      }

      handleChangeMinAmount = (event) => {
            this.setState({ refundUserMinAmount: event }, () => {
                  this.filterList()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        RefundUser: row2,
                        newFinancialDoc: false,
                  },
                  () => {}
            )
      }

      newFinancialDoc = (event) => {
            this.setState({
                  RefundUser: null,
                  newFinancialDoc: true,
                  refundUserMaxDate: "",
                  refundUserMinDate: "",
                  refundUserMaxAmount: "",
                  refundUserMinAmount: "",
                  refundPayMaxDate: "",
                  refundPayMinDate: "",
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFinancialDocPaing()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getFinancialDocPaing() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {})

                              var State = [{ value: "0", label: "همه انواع کاربر" }]
                              var State2 = [{ value: "0", label: "همه کاربران" }]
                              var State3 = [{ value: "0", label: "همه کارمندان" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    var toFind = arr.data[k].marketer_mode_id
                                    var filtered = State.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State.push({ value: arr.data[k].marketer_mode_id, label: arr.data[k].marketer_mode_namefa })
                                    }

                                    toFind = arr.data[k].refund_user_user_id
                                    filtered = State2.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State2.push({
                                                value: arr.data[k].refund_user_user_id,
                                                label: arr.data[k].user_name + " " + arr.data[k].user_family + "-" + arr.data[k].user_mobile,
                                          })
                                    }

                                    toFind = arr.data[k].refund_user_emloyee_id
                                    filtered = State3.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State3.push({
                                                value: arr.data[k].refund_user_emloyee_id,
                                                label: arr.data[k].employee_name + " " + arr.data[k].employee_family,
                                          })
                                    }
                              }
                              self.setState({ optionMarketingMode: State, selectedMarketingMode: State[0] })
                              self.setState({ optionUser: State2, selectedUser: State2[0] })
                              self.setState({ optionEmployee: State3, selectedEmployee: State3[0] })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_refund")
            fd.append("mode", "payed")
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/refunduser`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleUser = (selectedUser) => {
            this.setState({ selectedUser: selectedUser }, () => {
                  this.filterList()
            })
      }

      handleEmployee = (selectedEmployee) => {
            this.setState({ selectedEmployee: selectedEmployee }, () => {
                  this.filterList()
            })
      }

      handleMarketingMode = (selectedMarketingMode) => {
            this.setState({ selectedMarketingMode: selectedMarketingMode }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const {
                  refundUserMaxAmount,
                  refundUserMinAmount,
                  requestinfos,
                  selectedUser,
                  selectedEmployee,
                  selectedMarketingMode,
                  refundUserMinDate,
                  refundUserMaxDate,
                  refundPayMinDate,
                  refundPayMaxDate,
            } = this.state

            var timeStampMax = parseInt(
                  Moment(JDate.toGregorian(refundUserMaxDate.year, refundUserMaxDate.month, refundUserMaxDate.day)).format("x"),
                  0
            )
            var timeStampMin = parseInt(
                  Moment(JDate.toGregorian(refundUserMinDate.year, refundUserMinDate.month, refundUserMinDate.day)).format("x"),
                  0
            )
            var timeStampPayMax = parseInt(
                  Moment(JDate.toGregorian(refundPayMaxDate.year, refundPayMaxDate.month, refundPayMaxDate.day)).format("x"),
                  0
            )
            var timeStampPayMin = parseInt(
                  Moment(JDate.toGregorian(refundPayMinDate.year, refundPayMinDate.month, refundPayMinDate.day)).format("x"),
                  0
            )

            var i, temparray, temparray2, refund_user_date, refund_user_datepeyed
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < temparray.length; i++) {
                  refund_user_date = parseInt(Moment(temparray[i].refund_user_date, "YYYY-M-D HH:mm:ss").format("x"))
                  refund_user_datepeyed = parseInt(Moment(temparray[i].refund_user_datepeyed, "YYYY-M-D HH:mm:ss").format("x"))

                  if (
                        (temparray[i].refund_user_user_id === selectedUser.value || selectedUser.value === "0") &&
                        (temparray[i].refund_user_emloyee_id === selectedEmployee.value || selectedEmployee.value === "0") &&
                        (temparray[i].marketer_mode_id === selectedMarketingMode.value || selectedMarketingMode.value === "0") &&
                        (refund_user_date > timeStampMin || !timeStampMin) &&
                        (refund_user_date < timeStampMax || !timeStampMax) &&
                        (refund_user_datepeyed > timeStampPayMin || !timeStampPayMin) &&
                        (refund_user_datepeyed < timeStampPayMax || !timeStampPayMax) &&
                        (parseInt(refundUserMinAmount) <= parseInt(temparray[i].refund_user_amount) || refundUserMinAmount === "") &&
                        (parseInt(refundUserMaxAmount) > parseInt(temparray[i].refund_user_amount) || refundUserMaxAmount === "")
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getFinancialDocPaing()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getFinancialDocPaing()
            })
      }

      renderCustomInputMax = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ سند"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundUserMaxDate.year
                              ? this.state.refundUserMaxDate.year + "/" + this.state.refundUserMaxDate.month + "/" + this.state.refundUserMaxDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyMax}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputMin = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ سند"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundUserMinDate.year
                              ? this.state.refundUserMinDate.year + "/" + this.state.refundUserMinDate.month + "/" + this.state.refundUserMinDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyMin}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputPayMax = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ سند"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundPayMaxDate.year
                              ? this.state.refundPayMaxDate.year + "/" + this.state.refundPayMaxDate.month + "/" + this.state.refundPayMaxDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearPayDeyMax}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputPayMin = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ سند"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundPayMinDate.year
                              ? this.state.refundPayMinDate.year + "/" + this.state.refundPayMinDate.month + "/" + this.state.refundPayMinDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearPayDeyMin}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  refundUserMaxDate,
                  refundUserMinDate,
                  refundPayMaxDate,
                  refundPayMinDate,
                  refundUserMaxAmount,
                  refundUserMinAmount,
                  optionUser,
                  selectedUser,
                  optionEmployee,
                  selectedEmployee,
                  optionMarketingMode,
                  selectedMarketingMode,
                  RefundUser,
                  snackMode,
                  snackstr,
                  showSnack,
                  newFinancialDoc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست بزرگتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputMin} // render a custom input
                                                                                    value={refundUserMinDate}
                                                                                    onChange={this.setSelectedDayMin}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست کوچیکتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputMax} // render a custom input
                                                                                    value={refundUserMaxDate}
                                                                                    onChange={this.setSelectedDayMax}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پرداخت بزرگتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputPayMin} // render a custom input
                                                                                    value={refundPayMinDate}
                                                                                    onChange={this.setSelectedPayDayMin}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پرداخت کوچیکتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputPayMax} // render a custom input
                                                                                    value={refundPayMaxDate}
                                                                                    onChange={this.setSelectedPayDayMax}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداقل مبلغ"
                                                                        handleInputt={this.handleChangeMinAmount}
                                                                        value={refundUserMinAmount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداکثر مبلغ"
                                                                        handleInputt={this.handleChangeMaxAmount}
                                                                        value={refundUserMaxAmount}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">نوع کاربر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع کاربر"}
                                                                              value={selectedMarketingMode}
                                                                              onChange={this.handleMarketingMode}
                                                                              options={optionMarketingMode}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">کاربر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کاربر"}
                                                                              value={selectedUser}
                                                                              onChange={this.handleUser}
                                                                              options={optionUser}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">کارمند</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کارمند"}
                                                                              value={selectedEmployee}
                                                                              onChange={this.handleEmployee}
                                                                              options={optionEmployee}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          {newFinancialDoc || RefundUser === null ? null : (
                                                <Container component="main" maxWidth="lg">
                                                      <Paper elevation={4} className={classes.root}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Typography variant="h6">{"سند مالی در حال پرداخت"}</Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره سند:  " + RefundUser["refund_user_id"]}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"مبلغ درخواست:  "}
                                                                              <NumberFormat
                                                                                    displayType={"text"}
                                                                                    value={RefundUser["refund_user_amount"]}
                                                                                    thousandSeparator={true}
                                                                                    prefix={" ریال"}
                                                                              />
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={2}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نوع کاربر:  " + RefundUser["marketer_mode_namefa"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام کاربر:  " +
                                                                                    RefundUser["user_name"] +
                                                                                    " " +
                                                                                    RefundUser["user_family"] +
                                                                                    " -همراه:" +
                                                                                    RefundUser["user_mobile"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام بانک:  " + RefundUser["useracbank_bankname"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره حساب:  " + RefundUser["useracbank_numcard"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره شبا:  " + RefundUser["useracbank_sheba"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست: "}
                                                                              {new JDate(
                                                                                    new Date(
                                                                                          parseInt(
                                                                                                Moment(
                                                                                                      RefundUser["refund_user_date"],
                                                                                                      "YYYY-M-D HH:mm:ss"
                                                                                                ).format("x")
                                                                                          )
                                                                                    )
                                                                              ).format("YYYY/MM/DD") +
                                                                                    " " +
                                                                                    Moment(
                                                                                          RefundUser["refund_user_date"],
                                                                                          "YYYY-M-D HH:mm:ss"
                                                                                    ).format("HH:mm:ss")}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پرداخت: "}
                                                                              {new JDate(
                                                                                    new Date(
                                                                                          parseInt(
                                                                                                Moment(
                                                                                                      RefundUser["refund_user_datepeyed"],
                                                                                                      "YYYY-M-D HH:mm:ss"
                                                                                                ).format("x")
                                                                                          )
                                                                                    )
                                                                              ).format("YYYY/MM/DD") +
                                                                                    " " +
                                                                                    Moment(
                                                                                          RefundUser["refund_user_datepeyed"],
                                                                                          "YYYY-M-D HH:mm:ss"
                                                                                    ).format("HH:mm:ss")}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <Typography variant="h7">
                                                                              {"کد رهگیری: "}
                                                                              {RefundUser["refund_user_code"]}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام کارمند:  " +
                                                                                    RefundUser["employee_name"] +
                                                                                    " " +
                                                                                    RefundUser["employee_family"] +
                                                                                    " -همراه:" +
                                                                                    RefundUser["user_mobile"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newFinancialDoc}
                                                                              >
                                                                                    {"بستن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Paper>
                                                </Container>
                                          )}
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />

                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"refund_user_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "refund_user_id" ? order : false}
                                                                              >
                                                                                    {"آیدی سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "refund_user_id"}
                                                                                          direction={orderBy === "refund_user_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("refund_user_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"marketer_mode_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نوع کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "marketer_mode_id"}
                                                                                          direction={orderBy === "marketer_mode_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("marketer_mode_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"user_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_name"}
                                                                                          direction={orderBy === "user_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"همراه کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"refund_user_amount"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "refund_user_amount"}
                                                                                          direction={orderBy === "refund_user_amount" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("refund_user_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"refund_user_date"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "refund_user_date"}
                                                                                          direction={orderBy === "refund_user_date" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("refund_user_date")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"useracbank_bankname"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام بانک"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "useracbank_bankname"}
                                                                                          direction={
                                                                                                orderBy === "useracbank_bankname" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("useracbank_bankname")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"useracbank_sheba"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره شبا"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "useracbank_sheba"}
                                                                                          direction={orderBy === "useracbank_sheba" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("useracbank_sheba")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"refund_user_datepeyed"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ پرداخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "refund_user_datepeyed"}
                                                                                          direction={
                                                                                                orderBy === "refund_user_datepeyed" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("refund_user_datepeyed")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"refund_user_code"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"کد رهگیری"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "refund_user_code"}
                                                                                          direction={orderBy === "refund_user_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("refund_user_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"employee_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"کارمند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "employee_name"}
                                                                                          direction={orderBy === "employee_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("employee_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["refund_user_id"]}
                                                                                          value={row}
                                                                                          onClick={() => {
                                                                                                this.handleSelectRows(row)
                                                                                          }}
                                                                                    >
                                                                                          <TableCell key={"refund_user_id"} align={"center"}>
                                                                                                {row["refund_user_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"marketer_mode_namefa"} align={"center"}>
                                                                                                {row["marketer_mode_namefa"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_name"} align={"center"}>
                                                                                                {row["user_name"] + " " + row["user_family"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_mobile"} align={"center"}>
                                                                                                {row["user_mobile"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"refund_user_amount"} align={"center"}>
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["refund_user_amount"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell key={"refund_user_amount"} align={"center"}>
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        row["refund_user_date"],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            row["refund_user_date"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </TableCell>

                                                                                          <TableCell key={"useracbank_bankname"} align={"center"}>
                                                                                                {row["useracbank_bankname"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"useracbank_sheba"} align={"center"}>
                                                                                                {row["useracbank_sheba"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"refund_user_datepeyed"} align={"center"}>
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        row["refund_user_datepeyed"],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            row["refund_user_datepeyed"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </TableCell>

                                                                                          <TableCell key={"refund_user_code"} align={"center"}>
                                                                                                {row["refund_user_code"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"employee_name"} align={"center"}>
                                                                                                {row["employee_name"] + " " + row["employee_family"]}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRefundUserPayed)
